import { render, staticRenderFns } from "./CreateContactsModal.vue?vue&type=template&id=52e77e81&scoped=true"
import script from "./CreateContactsModal.vue?vue&type=script&lang=js"
export * from "./CreateContactsModal.vue?vue&type=script&lang=js"
import style0 from "./CreateContactsModal.vue?vue&type=style&index=0&id=52e77e81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e77e81",
  null
  
)

export default component.exports